import CaptionLayoutField from '@admin/components/mjson_designer/components/captionlayoutfield'
import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import React from 'react'

export const CaptionLayout = (props) => <ResponsiveField { ...props } component={ CaptionLayoutField } />
